import { render, staticRenderFns } from "./help.vue?vue&type=template&id=fff9b64a&scoped=true&"
import script from "./help.vue?vue&type=script&lang=js&"
export * from "./help.vue?vue&type=script&lang=js&"
import style1 from "./help.vue?vue&type=style&index=1&id=fff9b64a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff9b64a",
  null
  
)

export default component.exports